import { useEffect, useContext, useState } from "react";
import AppContext from "../../context";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { MdAccountCircle, MdOutlineDocumentScanner } from "react-icons/md";
import { FaRegCircleCheck } from "react-icons/fa6";
import { format } from "date-fns";
import { AddTappingMakananEntity, HasilTappingMakananEntity } from "../../entities/TappingMakananEntity";
import { FaRegWindowClose } from "react-icons/fa";
import css from "./TappingAdmin.module.css"
import PopupPilih from "../../components/Popup/PopupPilih";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import { LokasiService } from "../../services/lokasis";
import { TappingService } from "../../services/vendors_porsi";
import { VendorService } from "../../services/vendors";
import { VendorEntity } from "../../entities/VendorEntity";
import { FiRefreshCcw } from "react-icons/fi";

export default function TappingAdmin() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const contextUserEntity = context.contextUserEntity;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  const [showPopupPilih, setShowPopupPilih] = useState(false);
  const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();
  const [sisaPorsi, setSisaPorsi] = useState<{ regular: number | null, vegetarian: number | null }>({ regular: null, vegetarian: null });
  const [inputTapping, setInputTapping] = useState<AddTappingMakananEntity | null>(null);
  const [autoRefresh, setAutoRefresh] = useState<boolean>(true)
  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleSelectLokasi = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await LokasiService.GetAllLokasi();
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Lokasi',
        tableContent: resp,
        onClick: (row) => {
          setInputTapping((prevState: AddTappingMakananEntity | null) => {
            return new AddTappingMakananEntity({
              ...prevState,
              id_lokasi: row.id,
              lokasi: row.lokasi
            })
          })
        },
        onClose: () => { setShowPopupPilih(false) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSelectVendor = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorService.GetAllVendor();
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Vendor',
        tableContent: resp,
        onClick: (row: VendorEntity) => {
          setInputTapping((prevState: AddTappingMakananEntity | null) => {
            return new AddTappingMakananEntity({
              ...prevState,
              id_vendor: row.id,
              vendor: row.nama
            })
          })
        },
        onClose: () => { setShowPopupPilih(false) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const getPorsi = async () => {
    if (inputTapping == null || inputTapping.id_lokasi == null) return
    // contextShowLoadingFunc(true);
    try {
      const resp = await TappingService.GetAvailablePorsi(
        inputTapping?.id_lokasi,
        inputTapping?.id_vendor,
        format(inputTapping?.tanggal ?? new Date(), `yyyy-MM-dd`),
        inputTapping?.shift
      )
      setSisaPorsi({ regular: resp.sisa_regular, vegetarian: resp.sisa_vegetarian });
      setInputTapping((prevState: AddTappingMakananEntity | null) => {
        return new AddTappingMakananEntity({
          ...prevState,
          id_vendor_porsi: resp.id_vendor_porsi
        })
      })
      // setHasilTapping(new HasilTappingMakananEntity({ status: "READY" }))
      // contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      setSisaPorsi({ regular: null, vegetarian: null });
      setInputTapping((prevState: AddTappingMakananEntity | null) => {
        return new AddTappingMakananEntity({
          ...prevState,
          id_vendor_porsi: undefined,
        })
      })
      // setHasilTapping(new HasilTappingMakananEntity({ status: "UNAVAILABLE" }))
      // contextShowLoadingFunc(false);
    }
  }

  useEffect(() => {
    let shift_now: number = 0
    let hours: number = new Date().getHours()
    if (hours >= 7 && hours < 15) {
      shift_now = 1
    } else if (hours >= 15 && hours < 23) {
      shift_now = 2
    } else {
      shift_now = 3
    }
    setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
      return new AddTappingMakananEntity({
        ...prevState,
        tanggal: new Date(),
        tipe_makanan: "REGULAR",
        shift: shift_now
      })
    });
  }, [])

  useEffect(() => {
    const interval = setInterval(async () => {
      if (autoRefresh == true) {
        await getPorsi()
      }
    }, 5000)

    return () => {
      if (interval != null) {
        clearInterval(interval)
      }
    }
  }, [autoRefresh, inputTapping])

  useEffect(() => {
    getPorsi();
  }, [inputTapping?.id_lokasi, inputTapping?.id_vendor, inputTapping?.shift, inputTapping?.tanggal]);
  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <div style={{ height: "95%", overflowY: "auto", display: "flex", flexDirection: "column" }}>
          <div style={{ flex: "10%", color: "var(--header-color)", display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "0vh 1vw", }}>
            <h1 style={{ flex: "70%", textAlign: "left" }} >Tapping Makanan</h1>
            <div style={{ flex: "30%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", backgroundColor: "white", boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)", borderRadius: "20px" }} >
              <label htmlFor="auto_refresh" className={(autoRefresh ? css.tipeMakananChoosed : css.tipeMakananNotChoosed)} >
                Auto Refresh: 
                <input style={{ width: "5vw", cursor: "pointer" }} type="checkbox" checked={autoRefresh} id="auto_refresh" onClick={() => { setAutoRefresh((prev) => !prev) }} />
              </label>
            </div>
          </div>

          {/* Top Area */}
          <div style={{ flex: "50%", border: "0.7vh solid var(--header-color)", borderRadius: "2vh", backgroundColor: "white", margin: "2vh 1vw", display: "flex", flexDirection: "row", padding: "2vh 1vw" }}>
            <div style={{ flex: "20%", display: "flex", flexDirection: "column", fontWeight: "600" }}>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Nama Vendor</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Tanggal</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Shift </div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Lokasi</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
            </div>

            <div style={{ flex: "40%", display: "flex", flexDirection: "column" }}>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", padding: "0px 10px", fontSize: "16px" }} onClick={() => { handleSelectVendor() }}>
                <div>{inputTapping?.vendor ?? "Pilih Vendor Dahulu Disini "}</div>
                <div>▼</div>
              </div>
              <label htmlFor="tanggal" style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}>
                <input id="tanggal" type="date" style={{ border: "0px solid black", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", paddingLeft: 0, fontSize: "16px" }}
                  value={format(inputTapping?.tanggal ?? 0, "yyyy-MM-dd")}
                  onChange={(event) => {
                    setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                      return new AddTappingMakananEntity({
                        ...prevState,
                        tanggal: new Date(event.target.value)
                      })
                    });
                  }}
                />
              </label>
              <select style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", padding: "0px 10px", fontSize: "16px", maxWidth: "96%" }}
                value={inputTapping?.shift}
                onChange={(event) => {
                  setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                    return new AddTappingMakananEntity({
                      ...prevState,
                      shift: parseInt(event.target.value)
                    })
                  });
                }}>
                <option>1</option>
                <option>2</option>
                <option>3</option>
              </select>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", padding: "0px 10px", fontSize: "16px" }} onClick={() => { handleSelectLokasi() }}>
                <div>{inputTapping?.lokasi ?? "Pilih Lokasi Dahulu Disini "}</div>
                <div>▼</div>
              </div>
            </div>
          </div>

          {/* Bottom Area */}
          <div style={{ flex: "40%", borderRadius: "2vh", boxShadow: "3px 3px 10px rgba(0, 0, 0, 0.5)", backgroundColor: "white", margin: "2vh 1vw", padding: "2vh 1vw", display: "flex", flexDirection: "row", overflow: "hidden" }}>
            <div style={{ flex: "40%", display: "flex", flexDirection: "row", gap: "10px", cursor: "pointer" }} onClick={() => { getPorsi() }}>
              <div style={{ flex: "50%", backgroundColor: "var(--good-color)", borderRadius: "10px 0px 0px 10px", display: "flex", flexDirection: "column", position: "relative" }} >
                <div style={{ position: "absolute", top: "3%", right: "2%", color: "white" }}> <FiRefreshCcw /> </div>
                <div style={{ flex: "30%", display: "flex", alignItems: "end", justifyContent: "center", fontSize: "30px", fontWeight: "500", color: "white" }}>PORSI REGULAR</div>
                <div style={{ flex: "70%", display: "flex", alignItems: "start", justifyContent: "center", fontSize: "100px", fontWeight: "500", color: "var(--secondary-color)" }}>{sisaPorsi.regular ?? 'N/A'}</div>
              </div>
              <div style={{ flex: "50%", backgroundColor: "var(--good-color)", borderRadius: "0px 10px 10px 0px", display: "flex", flexDirection: "column", position: "relative" }} >
                <div style={{ position: "absolute", top: "3%", right: "2%", color: "white" }}> <FiRefreshCcw /> </div>
                <div style={{ flex: "30%", display: "flex", alignItems: "end", justifyContent: "center", fontSize: "30px", fontWeight: "500", color: "white" }}>PORSI VEGETARIAN</div>
                <div style={{ flex: "70%", display: "flex", alignItems: "start", justifyContent: "center", fontSize: "100px", fontWeight: "500", color: "var(--secondary-color)" }}>{sisaPorsi.vegetarian ?? 'N/A'}</div>
              </div>
            </div>
          </div>

        </div>
        <div style={{ height: "5%", display: "flex", alignItems: "end", justifyContent: "center" }}>
          <div style={{ color: "var(--tertiary-color)", fontWeight: "600" }}>© Traxboards 2024 By Nagamas Putrajaya Engineering</div>
        </div>

        {popUpPilihEntity != null
          ? <PopupPilih
            showPopup={showPopupPilih}
            setShowPopup={setShowPopupPilih}
            popUpPilihEntity={popUpPilihEntity}
          />
          : <></>}

      </div >
    </>
  );
}
